import { IBaseListInputProps, BaseListInput } from "./BaseListInput";

import * as React from "react";
import * as $ from "jquery";

export interface ISelectSpecificProps<TOption> extends IBaseListInputProps<TOption> {
    placeholder?: string;
    ariaLabel?: string;
    ariaDescribedby?: string;
    ariaInvalidCanBeShown?: boolean;
    ariaInvalidShouldBeShown?: boolean;
}

export interface ISelectProps<TOption> extends ISelectSpecificProps<TOption>, React.Props<Select<TOption>> {
    // NOTE: leave empty
}

export class Select<TOption> extends BaseListInput<TOption, ISelectProps<TOption>> {
    private _select: HTMLSelectElement;

    constructor(props: ISelectProps<TOption>) {
        super(props);
    }

    public render(): JSX.Element {
        const defaultOption: JSX.Element = this.getDefaultOption();
        const options: JSX.Element[] = this.getOptions();
        const selectedIndex: string =
            this.state.selectedIndex !== null && this.state.selectedIndex !== undefined
                ? this.state.selectedIndex.toString()
                : null;

        return (
            <>
                <select
                    disabled={this.state.disable == true ? true : this.props.disabled}
                    value={selectedIndex}
                    onChange={(event: React.SyntheticEvent) => this.onChange(event)}
                    onBlur={() => this.onBlur()}
                    className={this.props.cssInput || "form-input"}
                    ref={(select: HTMLSelectElement) => (this._select = select)}
                    id={this.props.id}
                    tabIndex={this.props.tabIndex}
                    aria-label={this.props.ariaLabel}
                    aria-describedby={this.props.ariaDescribedby}
                    aria-invalid={
                        (!this.state.isValid || this.props.ariaInvalidShouldBeShown) && this.props.ariaInvalidCanBeShown
                    }
                >
                    {defaultOption}
                    {options}
                </select>
                <span className="controls-select-chevron" aria-hidden="true"></span>
            </>
        );
    }

    protected getSelectedOption(selectedIndex: number): TOption {
        if (selectedIndex === null || selectedIndex === undefined) {
            selectedIndex = this._select && this._select.selectedIndex;
            if (this.props.placeholder) {
                selectedIndex--;
            }
        }

        if (selectedIndex < 0 || selectedIndex >= this.options.length) {
            return null;
        }

        return this.options[selectedIndex];
    }

    protected isHidden(): boolean {
        return $(this._select).is(":hidden");
    }

    private getOptions(): JSX.Element[] {
        return this.options && this.options.map((option: TOption, index: number) => this.getOption(option, index));
    }

    private getOption(option: TOption, index: number): JSX.Element {
        const text = this.props.getText(option);

        return (
            <option value={index.toString()} key={index.toString()}>
                {/* {" "} */}
                {text}
            </option>
        );
    }

    private getDefaultOption(): JSX.Element {
        return this.props.placeholder ? <option value="-1">{this.props.placeholder}</option> : null;
    }
}
